import {Cookie} from './cookie';
import {Video} from './video';
import {SmsNotify} from './smsNotify';

export class GsAcknowledgePopup {
    constructor() {
        this.cookie = new Cookie();
        this.smsNotify = new SmsNotify();
        this.cookieNames = {
            popup: 'gs_acknowledge_popup_2024',
            member: 'gs_acknowledge_member',
            tracking: 'gs_acknowledge_tracking',
        };
        let _this = this;
        let clinic;
        let video;
        jQuery(document).ready(function () {
            $('#region-select').change(function () {
                $('[data-clinic-select] option[data-selected]').removeAttr('selected');
                $('[data-clinic-select] option[data-selected]').removeAttr('data-selected');
                $('[data-clinic-select]').removeClass('d-inline-block');
                $('[data-clinic-select]').removeAttr('required')

                let region = $(this).children("option:selected").val();
                if (region === 'no-region') {
                    $('#gs-clinic').val('no-region');
                }

                clinic = $('#' + region);
                if (clinic.length > 0) {
                    clinic.attr('required', 'required');
                    clinic.toggleClass('d-inline-block');
                    clinic.trigger('change');
                }
            });

            $('[data-clinic-select]').change(function () {
                $('#gs-clinic').val($(this).children("option:selected").val())
            })

            if ($.fn.fancybox) {
                if (!_this.hasCookie()) {
                    _this.openPopup();
                }
                jQuery('#gs-acknowledge-popup input, #gs-acknowledge-popup label').on('click', function (e) {
                    e.stopImmediatePropagation();
                });
                jQuery("#gs-acknowledge-popup .btn").on('click', function (e) {
                    e.stopImmediatePropagation();
                    _this.createCookie();
                    _this.submitForm();
                });
            }
            $('#gs-acknowledge-open').on('click', function (e) {
                _this.openPopup();

            })
            if($('[data-acknowledge-video]').length > 0) {
                video = new Video('[data-acknowledge-video]')
            }

        });
    }

    openPopup() {
        jQuery("#gs-clinic-required").addClass('d-none');
        jQuery("#gs-acknowledge-popup")
            .fancybox({
                buttons: [],
                smallBtn: false,
                clickSlide: false,
                clickOutside: false,
                modal: true,
                touch: {
                    vertical: false,
                    momentum: false
                },
            })
            .trigger('click');
        $('[data-clinic-select] option[data-selected]').parent().addClass('d-inline-block');
    }

    closePoup() {
        if ($('.c-popup-video').length > 0) $('.c-popup-video').remove();
        $.fancybox.close();
    }

    hasCookie() {
        return this.cookie.has(this.cookieNames.popup);
    }

    createCookie() {
        this.cookie.set(this.cookieNames.popup, true, 3650);
        this.cookie.set(this.cookieNames.member, this.isChecked('#gs-member'), 3650);
        this.cookie.set(this.cookieNames.tracking, this.isChecked('#gs-tracking'), 3650);
    }

    submitForm() {
        let clinic = this.getClinic('#gs-clinic')

        if (clinic) {
            let xhr = new XMLHttpRequest();
            xhr.open("POST", 'api/acknowledge/', true);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.send(JSON.stringify({
                "member": this.isChecked('#gs-member'),
                "tracking": this.isChecked('#gs-tracking'),
                "clinic": clinic
            }));

            if (this.smsNotify.isAvailable) {
                if (this.smsNotify.submit()) {
                    this.closePoup();
                }
             } else {
                this.closePoup();
            }
        }
    }

    isChecked(selector) {
        return jQuery(selector).is(':checked');
    }

    showRequiredMassage() {
        jQuery("#gs-clinic-required").removeClass('d-none');
    }

    getClinic(selector) {
        if (jQuery('#no-clinic').length === 0) {
            if (jQuery(selector).val() === 'no-region') {
                this.showRequiredMassage();
                return null;
            }
            return jQuery(selector).val();
        }
        return "no-clinic";
    }
}
